<!--
数字自动填充，主要用户 tab 页签中的数字填充对齐，避免 tab 数字变化 tab 宽度跳动 导致active tab 下划线错位
props:
  value: 要填充的数字
  length: 目标长度
  padType: 填充字符类型
-->
<template>
  <div class="num-padding">
    <slot :paddedValue="paddedValue">{{ paddedValue }}</slot>
  </div>
</template>

<script>
export default {
  name: 'NumPadding',
  props: {
    // 要填充的数字
    value: {
      type: [Number, String],
      required: true
    },
    // 目标长度
    length: {
      type: Number,
      default: 3
    },
    // 填充字符类型
    padType: {
      type: String,
      default: 'halfWidth', // 'fullWidth' | 'halfWidth' | 'normal'
      validator: value => ['fullWidth', 'halfWidth', 'normal'].includes(value)
    }
  },
  computed: {
    // 根据类型获取填充字符
    padChar() {
      switch (this.padType) {
        case 'fullWidth':
          return '　' // 全角空格
        case 'halfWidth':
          return ' ' // 半角空格
        case 'normal':
        default:
          return ' ' // 普通空格
      }
    },
    // 计算填充后的值
    paddedValue() {
      let str = ''
      if (this.value == null || this.value === undefined) {
        str = '0'
      } else {
        str = this.value.toString()
      }

      if (str.length >= this.length) {
        return str
      }

      // 使用指定类型的空格进行填充
      return str + this.padChar.repeat(this.length - str.length)
    }
  }
}
</script>

<style scoped>
.num-padding {
  display: inline-block;
}
</style>
